import { clsx } from '@/lib/utils';
import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Navbar from './navbar';
import Sidebar from './sidebar';
import { useCurrentUser } from '@/lib/hooks/current-user/useCurrentUser';
import { LoadingScreen } from '../ui/loading-screen/loading-screen';
import { useAppDispatch, useAppSelector } from '@/lib/hooks';
import { setRoleStatus } from '@/redux/slices/auth';
import { ChristmasDecor } from '@/components/christmas-decor/christmas-decor';
import { useUserPreferencesStore } from '@/store/user-preferences.store';

const Layout = () => {
    const { isSuperAdmin, isLoading, isSuccess } = useCurrentUser();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { roleIndentified } = useAppSelector((state) => state.user);
    const sidebarCollapsed = useUserPreferencesStore((state) => state.sidebarCollapsed);

    useEffect(() => {
        if (!roleIndentified && isSuccess) {
            if (isSuperAdmin) {
                navigate('/house-managers');
            }
            dispatch(setRoleStatus(true));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [roleIndentified, isSuccess]);

    if (isLoading) return <LoadingScreen />;

    return (
        <div className="relative min-h-screen md:flex" data-dev-hint="container">
            <input type="checkbox" id="menu-open" className="hidden" />

            <aside
                id="sidebar"
                className={clsx('flex-shrink-0', sidebarCollapsed ? 'w-16' : 'w-72')}>
                <Sidebar />
            </aside>

            <main
                id="content"
                className="flex-1 bg-accent min-h-screen h-max w-full md:w-[calc(100%-24rem)]">
                <Navbar />
                <ChristmasDecor />
                {/* Full width so the scrollbar sits at the window edge, with a stable gutter so the centered content
                    doesn't shift when the scrollbar appears. `relative` keeps absolutely positioned page content
                    (e.g. `sr-only` labels) inside this scroll container instead of stretching the whole page. */}
                <div className="relative h-[calc(100vh-64px)] overflow-auto [scrollbar-gutter:stable]">
                    <div className="max-w-[1500px] mx-auto px-8 py-6">
                        <Outlet />
                    </div>
                </div>
            </main>
        </div>
    );
};

export default Layout;
